import React from 'react';
import { CloseIcon } from '../assets/svg/MenuIcons';

interface ModalProps {
  customStyle?: string;
  isOpen: boolean;
  onClose: () => void;
  cardStatus?: boolean;
  title?: string;
  content?: string;
  buttonText?: string;
  extraButtonText?: string;
  onExtraButtonClick?: () => void;
  onThirdButtonClick?: () => void;
  btnIcon?: React.ReactNode;
  icon?: React.ReactNode;
  jsxContent?: React.ReactNode;
  closeIcon?: boolean;
  onCloseIconClick?: () => void;
  buttonClassName?: string;
  width?: string;
  height?: string;
  padding?: string;
  dasboardPopup?: boolean;
  thirdButtonText?: string;
  buttonstyle?: string;
  extrabuttonstyle?: string;
  thirdbuttonstyle?: string;
}

const CommanModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  cardStatus,
  jsxContent,
  buttonText,
  extraButtonText,
  onExtraButtonClick,
  onThirdButtonClick,
  closeIcon = true,
  onCloseIconClick,
  buttonClassName = 'flex-col mt-10',
  width = 'max-w-xs',
  height = '',
  padding = 'p-6',
  dasboardPopup = false,
  thirdButtonText,
  buttonstyle,
  extrabuttonstyle,
  thirdbuttonstyle,
}) => {
  if (!isOpen) return null; // Do not render the modal if it's closed
  const primaryBtnStyle =
    'bg-red-600 text-white py-2 px-4 hover:bg-red-700 focus:outline-none w-full min-h-[48px] focus:ring-2 focus:ring-red-500 focus:ring-opacity-50';
  const secondaryBtnStyle =
    'w-full h-auto bg-white hover:bg-red-50 text-primary-red font-medium py-2 px-4 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 border border-1 border-primary-red';
  const thirdBtnStyle =
    'min-h-[48px] w-full h-10 bg-white hover:underline text-primary-red font-medium py-2 px-4 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 border-none border-1 border-primary-red';
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      aria-labelledby="modal-title"
      aria-modal="true"
      role="dialog"
    >
      <div
        id="modal-title"
        className={`bg-white ${padding} md:rounded-lg rounded-none ${width} mx-auto relative ${height}`}
        role="alert"
      >
        <div className={`${closeIcon && 'mt-[20px]'}`}>{jsxContent}</div>
        <div
          className={` flex ${thirdButtonText ? 'gap-2' : 'gap-4'} ${buttonClassName}`}
        >
         {buttonText && (
           <button
            aria-label={buttonText}
            onClick={onClose}
            className={`${
              extraButtonText
                ? dasboardPopup
                  ? primaryBtnStyle
                  : buttonstyle == 'primary'
                    ? primaryBtnStyle
                    : secondaryBtnStyle
                : primaryBtnStyle
            }`}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onClose();
              }
            }}
          >
            {buttonText}
          </button>
        )}
          {extraButtonText && onExtraButtonClick && (
            <button
              aria-label={extraButtonText}
              onClick={onExtraButtonClick}
              className={`${
                extrabuttonstyle === 'secondary'
                  ? secondaryBtnStyle
                  : dasboardPopup
                    ? secondaryBtnStyle
                    : primaryBtnStyle
              }`}
            >
              {extraButtonText}
            </button>
          )}
          <div>
            {thirdButtonText && (
              <button
                onClick={onThirdButtonClick}
                className={
                  thirdbuttonstyle == 'secondary'
                    ? secondaryBtnStyle
                    : thirdBtnStyle
                }
                aria-label={thirdButtonText}
              >
                {thirdButtonText}
              </button>
            )}
          </div>
        </div>

        {closeIcon && (
          <div
            className="absolute top-5 right-5"
            onClick={onCloseIconClick}
            data-testid="close-icon"
          >
            <CloseIcon width={'24'} height="24" fill="#1F1F1F" />
          </div>
        )}
      </div>
    </div>
  );
};

export default CommanModal;
